import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EmailTemplate } from 'src/app/core/models/email-template.model';

@Injectable({ providedIn: 'root' })
export class EmailTemplateService {

    constructor(
        private http: HttpClient
    ) {
    }

    getEmailTemplates() {
        return this.http.get<EmailTemplate[]>(`/api/emailTemplate`);
    }

    getEmailTemplate(id: string) {
        return this.http.get<EmailTemplate>(`/api/emailTemplate/${id}`);
    }

    saveEmailTemplate(emailTemplate: EmailTemplate) {
        return this.http.post<EmailTemplate>(`/api/emailTemplate`, emailTemplate);
    }

    updateEmailTemplate(id: string, emailTemplate: EmailTemplate) {
        return this.http.put<EmailTemplate>(`/api/emailTemplate/${id}`, emailTemplate);
    }

    delete(id: string) {
        return this.http.delete(`api/emailTemplate/${id}`)
    }

    getEmailTemplateByType(type: string) {
        return this.http.get<EmailTemplate>(`/api/emailTemplate/type/${type}`);
    }

    saveEmailTemplateByType(type: string, emailTemplate: EmailTemplate) {
        return this.http.put<EmailTemplate>(`/api/emailTemplate/type/${type}`, emailTemplate);
    }
}

